import Item from './Item.vue'

export default {
  Item,
}
